import React from 'react';
import {Form,Input,Button,Checkbox,message,Spin,Switch,Select, Divider,Result,Card} from 'antd';
import axios from 'axios';
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
var CryptoJS = require("crypto-js");

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''
var sacco= ''
var username= ''


const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

class  PortalUserForm extends React.Component {

  state = {
    registation_form:null,  
    datarequested:false,
    email:'',

    sur_name:'',
    other_name:'',
    phone:'',
    message_status:''

  }


  formRef = React.createRef();

  componentDidMount() {

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   }else{
      username=''
   }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    this.setState({datarequested:false})

  }





    // on form submit heree
    onFinish = values => {
      this.setState({datarequested:true})

      let form_data = new FormData();
      form_data.append('username', username);
      form_data.append('email', this.state.email);

      form_data.append('sur_name', this.state.sur_name);
      form_data.append('other_name', this.state.other_name);
      form_data.append('phone', this.state.phone);

      this.state.registation_form==null?
      console.log("No file")
      :
      form_data.append('registation_form', this.state.registation_form, this.state.registation_form?this.state.registation_form.name:"");

      //Register the account first
      axios.post(serverconfig.backendserverurl+'/customqueries/create_portaluser',form_data)
      .then(res =>{
        this.setState({datarequested:false})
        this.setState({datasubmittedsuccessfully:true})
        this.setState({message_status:res.data.message})

      })
    .catch(error => console.log(error))

    };


  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>  
         </div>
      )

    }else{

      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
               <Card>
                <Result
                status="success"
                title="Successfully User Creation "
                subTitle={this.state.message_status}
                extra={[
                  <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                ]}
                />

                </Card>

          </div>

        )

      }else{

        return (

          <div>
            <h3>Create new portal user account here</h3>
          <Form
            name="register"
            onFinish={this.onFinish}
          >
  
              <Form.Item
              label="E-mail"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ]}
            >
              <Input type="mail" 
              prefix={<MailOutlined className="site-form-item-icon" />} 
              placeholder="Email" value={this.state.email} 
              onChange={(val)=>{this.setState({email:val.target.value})}}  />
  
            </Form.Item>


            <Form.Item label="Form attachment"
              name="registation_form">
                <Input  type="file" accept=".pdf" 
                placeholder="registation_form" 
                onChange={(e) => this.setState({ registation_form: e.target.files[0]})}/>
            </Form.Item>  
            <Divider></Divider>


            <FormItem label="Sur Name"
              name="sur_name"
              rules={[
                {
                  required: true,
                  message: 'Please input sur_name',
                },
              ]}
            >
              <Input name="sur_name"  placeholder="sur_name."
              value={this.state.sur_name} 
              onChange={(val)=>{this.setState({sur_name:val.target.value})}} />
            </FormItem>

            <FormItem label="Other Name"
              name="other_name"
              rules={[
                {
                  required: true,
                  message: 'Please input other_name',
                },
              ]}
            >
              <Input name="other_name"  placeholder="other_name."
              value={this.state.other_name} 
              onChange={(val)=>{this.setState({other_name:val.target.value})}} />
            </FormItem>

            <FormItem label="Phone"
              name="phone"
              rules={[
                {
                  required: true,
                  message: 'Please input phone',
                },
              ]}
            >
              <Input name="phone"  
              placeholder="phone."
              type='number'
              value={this.state.phone} 
              onChange={(val)=>{this.setState({phone:val.target.value})}} />
            </FormItem>
         
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Create Account
              </Button>
            </Form.Item>
            
          </Form>

          </div>
        );
      }






    }

  }

}


export default PortalUserForm;


